import { render, staticRenderFns } from "./WsInfoRouterLink.vue?vue&type=template&id=4c5ba07a&"
import script from "./WsInfoRouterLink.vue?vue&type=script&lang=js&"
export * from "./WsInfoRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports